import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {reforecastStartMonthString} from "./common";

export function RenderUpdateReforecastStartMonth(props: RendererProps): ReactElement {
    const monthIdx = props.variables["reforecastStartMonthIndex"];

    return <>{reforecastStartMonthString(monthIdx)}</>;
}